// extracted by mini-css-extract-plugin
export default {"form":"FormCreateTask_form__4ATCh"};